export enum ControlButtonSize {
    SIZE_20     = 20,
    SIZE_24     = 24, // small i.e. glist, table row, etc ...
    SIZE_26     = 26, // text editor control panel
    SIZE_28     = 28, // Stantdard control panel
    SIZE_30     = 30,
}